import React from 'react';

type WashVariant = 'a' | 'b' | 'c';

interface WatercolorWashProps {
  variant?: WashVariant;
  color?: string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  size?: number;
}

const PATHS: Record<WashVariant, string> = {
  a: 'M40 90 Q20 30 90 40 Q170 30 160 110 Q170 180 90 170 Q20 180 40 90Z',
  b: 'M50 70 Q40 20 110 30 Q180 50 160 110 Q170 170 100 180 Q30 170 50 70Z',
  c: 'M30 80 Q20 20 100 30 Q180 30 170 100 Q180 170 110 180 Q20 170 30 80Z',
};

const WatercolorWash: React.FC<WatercolorWashProps> = ({
  variant = 'a',
  color = 'var(--ochre)',
  opacity = 0.5,
  style,
  className,
  size = 360,
}) => (
  <svg
    aria-hidden="true"
    className={`wc-wash ${className || ''}`}
    style={{
      position: 'absolute',
      pointerEvents: 'none',
      mixBlendMode: 'multiply',
      filter: 'blur(2px)',
      opacity: 0.42,
      zIndex: 0,
      width: size,
      height: size,
      ...style,
    }}
    viewBox="0 0 200 200"
  >
    <path d={PATHS[variant]} fill={color} opacity={opacity} />
  </svg>
);

export default WatercolorWash;
